import { DefaultPageSize } from './DefaultPageSize';

export const Pagination = Object.freeze({
  pageSize: DefaultPageSize,
});
